import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faRotate, faUpload, faDownload, faFilePdf, faPenToSquare, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { del } from '../../utils/api';
import config from '../../config';
import './ExhibitorViewFiles.css';
const MAX_FILES = 3; // Максимальное число файлов на одного экспонента

const ExhibitorViewFiles = ({ exhibitor }) => {
	const { t } = useTranslation();
    const navigate = useNavigate();
    const [ files, setFiles ] = useState(exhibitor.files);

    const onRemoved = (file) => {
        const newFiles = Array.from(files);
        const index = newFiles.findIndex(f => f.file === file.file);
        if(index < 0) return;
        newFiles.splice(index, 1);
        setFiles(newFiles);
    };

    return (
		<div>
	    	<h2>{t('exhibitorview.files')}</h2>
            <div>{t('exhibitorview.files_text')}</div>

            {files && 
            <div className='Files'>
                {files.map((file, index) => (
                    <ViewFile
                        key={index}
                        file={file}
                        exhibitor={exhibitor._id}
                        onRemoved={onRemoved}
                    />
                ))}
            </div>}

            {(!files || files.length < MAX_FILES) &&
            <div className='Upload'>
                <div className='Icon'>
                    <Icon icon={faUpload} size='2x' fixedWidth/>
                </div>
                <div className='Text'>
                <span onClick={() => navigate('/cabinet/exhibitoreditfile')} className='a'>
                    {t('exhibitorview.files_add')}
                </span>
                </div>
            </div>}

		</div>
	);
};

ExhibitorViewFiles.propTypes = {
    exhibitor: PropTypes.object.isRequired,
};

// Вспомогательный компонент для отображения одного файла
const ViewFile = ({ file, exhibitor, onRemoved }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
	const [ isRemoving, setIsRemoving ] = useState(false);
    const [ error, setError ] = useState(false);

    const onEdit = () => {
        navigate('/cabinet/exhibitoreditfile/' + file.file);
    };

	const onDownload = () => {
		const url  = config.FILES_URL + file.base + file.file;
		window.open(url);
	};

	const onRemove = async () => {
        if(!window.confirm(t('exhibitorview.files_delete_confirm'))) {
			return;
		}
        setIsRemoving(true);
        setError(false);
        const result = await del('/file', { exhibitor, file: file.file });
        if(result.error) {
            setError(true);
        } else {
			onRemoved(file);
        }
        setIsRemoving(false);
	};

    return (
        <div className='File'>
            <div className='Icon'>
                {isRemoving ?
                    <Icon icon={faRotate} size='2x' fixedWidth className='fa-spin'/> :
                    <React.Fragment>
                        {error ? 
                            <Icon icon={faTriangleExclamation} size='2x' fixedWidth/> :
                            <Icon icon={faFilePdf} size='2x' fixedWidth/> }
                    </React.Fragment>}
            </div>
            <div className='Text'>
                <div className='b'>{file.name[lang]}</div>
                {(file.descr && file.descr[lang]) && <div>{file.descr[lang]}</div>}

                {!isRemoving &&
                <p className='small'>
                    <Icon icon={faDownload}/>&nbsp;
                    <span
                        className='a'
                        onClick={() => onDownload()}
                    >
                        {t('exhibitorview.files_download')}
                    </span>&nbsp;&nbsp;&nbsp;

                    <Icon icon={faPenToSquare}/>&nbsp;
                    <span
                        className='a'
                        onClick={() => onEdit()}
                    >
                        {t('exhibitorview.files_edit')}
                    </span>&nbsp;&nbsp;&nbsp;

                    <Icon icon={faTrashCan}/>&nbsp;
                    <span
                        className='a'
                        onClick={() => onRemove()}
                    >
                        {t('exhibitorview.files_delete')}
                    </span>
                </p>}
            </div>
        </div>
    );
};

export default ExhibitorViewFiles;
